<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/billing-data']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-6">
      <h2 class="col pb-2 m-0 title">
        {{ "SIDEBAR_BILLINGDATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "ONDEMANDBILLING_SUBTITLE" | translate }}
      </h6>
    </div>
    @if (
      authService.isAuthorized([
        PermissionEnum.Ondemand_energyregister_download,
      ])
    ) {
      <div
        class="col-md-5 d-flex justify-content-end align-items-center gap-2 pe-5"
      >
        <div class="download-button ps-3 pe-3 pb-2 pt-2" (click)="download()">
          <svg-icon
            alt="Download"
            class="hover-effect"
            src="assets/core/table/download.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }} {{ "INTERVAL" | translate }}
          </td>
          <td>{{ "ENERGYREGISTERS_ACTIVEENERGY" | translate | uppercase }}</td>
          <td>
            {{ "ENERGYREGISTERS_REACTIVEENERGY" | translate | uppercase }}
          </td>
          <td>
            {{ "ENERGYREGISTERS_APPARENTENERGY" | translate | uppercase }}
          </td>
          <td class="custom-width">
            {{ "POWERFACTOR" | translate | uppercase }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Active Energy -->
          <td>
            <div class="group two-items">
              <div class="cell">
                <img alt="Import" src="assets/load-profile/im.svg" />
                <span [attr.title]="item.activeEnergyImport + ' WH'">
                  {{ item.activeEnergyImport! | unitConverter: "WH" }}
                </span>
              </div>
              <div class="cell">
                <img class="Export" src="assets/load-profile/ex.svg" />
                <span [attr.title]="item.activeEnergyExport + ' WH'">
                  {{ item.activeEnergyExport! | unitConverter: "WH" }}
                </span>
              </div>
            </div>
          </td>

          <!-- Reactive Energy -->
          <td>
            <div class="group two-items">
              <div class="cell">
                <img alt="Import" src="assets/load-profile/im.svg" />
                <span [attr.title]="item.reactiveEnergyImport + ' VARh'">
                  {{ item.reactiveEnergyImport! | unitConverter: "VARh" }}
                </span>
              </div>
              <div class="cell">
                <img alt="Export" src="assets/load-profile/ex.svg" />
                <span [attr.title]="item.reactiveEnergyExport + ' VARh'">
                  {{ item.reactiveEnergyExport! | unitConverter: "VARh" }}
                </span>
              </div>
            </div>
          </td>

          <!-- Apparent Energy -->
          <td>
            <div class="group two-items">
              <div class="cell">
                <img alt="Import" src="assets/load-profile/im.svg" />
                <span [attr.title]="item.apparentEnergyImport + ' VAH'">
                  {{ item.apparentEnergyImport! | unitConverter: "VAH" }}
                </span>
              </div>
              <div class="cell">
                <img alt="Export" src="assets/load-profile/ex.svg" />
                <span [attr.title]="item.apparentEnergyExport + ' VAH'">
                  {{ item.apparentEnergyExport! | unitConverter: "VAH" }}
                </span>
              </div>
            </div>
          </td>

          <!-- Power Factor -->
          <td>
            <div class="group three-items">
              <div class="cell">
                <img alt="Line 1" src="assets/load-profile/l1.svg" />
                <span [attr.title]="item.powerFactorL1 "
                  >{{ item.powerFactorL1! | number: "1.0-4" }} </span
                >
              </div>
              <div class="cell">
                <img alt="Line 2" src="assets/load-profile/l2.svg" />
                <span [attr.title]="item.powerFactorL2 "
                  >{{ item.powerFactorL2! | number: "1.0-4" }} </span
                >
              </div>
              <div class="cell">
                <img alt="Line 3" src="assets/load-profile/l3.svg" />
                <span [attr.title]="item.powerFactorL3 "
                  >{{ item.powerFactorL3! | number: "1.0-4" }}</span
                >
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfCommands"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>
